import * as t from 'io-ts';

import {RMessageUidRef} from '../../../models/api/apiTypes';
import {RAsyncStatus} from '../../appTypes';
import {RPanelCancelTokenId} from '../panelCancelTokenId';
import {PanelTypesEnum, RAppPanelId, REmlPanelId, RPanelStateBase} from '../panelStateBase';

/*
 * Runtime type.
 */

export enum EmlSourceTypesEnum {
  FILE = 'FILE',
  ATTACHMENT = 'ATTACHMENT',
}

const RFileEmlSource = t.type({
  type: t.literal(EmlSourceTypesEnum.FILE),
  emlFileContents: t.string,
});

const RAttachmentEmlSource = t.type({
  type: t.literal(EmlSourceTypesEnum.ATTACHMENT),
  attachmentUid: t.string,
});

const REmlSource = t.taggedUnion('type', [RFileEmlSource, RAttachmentEmlSource]);

export const REmlPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: REmlPanelId,
    type: t.literal(PanelTypesEnum.EML),
    popupAppPanelId: RAppPanelId,
    source: REmlSource,
    status: RAsyncStatus,
    messageUid: t.union([RMessageUidRef, t.undefined]),
    cancelTokenId: RPanelCancelTokenId,
  }),
]);

/*
 * Types.
 */

export interface FileEmlSource extends Readonly<t.TypeOf<typeof RFileEmlSource>> {}
export interface AttachmentEmlSource extends Readonly<t.TypeOf<typeof RAttachmentEmlSource>> {}

export type EmlSource = FileEmlSource | AttachmentEmlSource;

export interface EmlPanelState extends Readonly<t.TypeOf<typeof REmlPanelStateDirty>> {}
export const REmlPanelState = t.clean<EmlPanelState>(REmlPanelStateDirty as any);
